<script>
import { fabric } from 'fabric';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'AddSVGImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'pen',
    };
  },
  methods: {
    action() {
      this.addArrow();
    },
    addSVG(svg) {
      // eslint-disable-next-line
      const path = fabric.loadSVGFromString(svg, (objects, options) => {
        this.canvas.renderOnAddRemove = false;
        this.canvas.add(this.canvas, objects);
        this.canvas.renderOnAddRemove = true;
        this.canvas.renderAll();
      });
    },
    addArrow() {
      const svg = `<?xml version="1.0" encoding="utf-8"?>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="168px" height="30.66px" viewBox="0 0 168 30.66" style="enable-background:new 0 0 168 30.66;" xml:space="preserve">
        <defs></defs>
        <g>
      <path d="M139.62,30.59c10.39-2.08,19.29-7.42,27.31-13.95c1.78-1.48,1.19-4.45-0.59-5.64c-9.5-5.34-19.89-9.8-30.87-10.98
        c-3.27-0.3-3.56,4.75-0.59,5.34c8.01,2.08,15.73,5.05,23.15,8.9c-2.08,1.48-4.45,2.97-6.83,4.16c2.08-2.08,1.19-6.83-2.67-6.83
        C100.14,11.29,50.28,0.31,2.49,8.92c-3.86,0.59-2.97,7.12,0.89,6.83c48.68-3.86,96.47,3.56,145.15,3.86c0.3,0,0.59,0,0.59,0
        c-3.56,1.78-7.12,2.97-11.28,3.86C133.09,24.06,134.87,31.48,139.62,30.59z"/>
    </g>
    </svg>
     `;
      this.addSVG(svg);
    },

  },
};
</script>
